import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('checkboxInput', [
  'focusVisible',
]);

/**
 * Checkbox icon size constant
 */
export const CHECKBOX_ICON_SIZE = '18px' as const;

const getCheckboxInputCss = css`
  /* Extended hit area for checkbox */
  --input-checkbox-hit-area: 1px;

  padding: var(--input-checkbox-hit-area);

  svg {
    /* Border radius for checkbox and focus visible state border */
    border-radius: var(--cds-border-radius-50);
  }
`;

export default getCheckboxInputCss;
